import { render, staticRenderFns } from "./ListHoiChan.vue?vue&type=template&id=baa9abc0&scoped=true"
import script from "./ListHoiChan.vue?vue&type=script&lang=js"
export * from "./ListHoiChan.vue?vue&type=script&lang=js"
import style0 from "./ListHoiChan.vue?vue&type=style&index=0&id=baa9abc0&prod&lang=scss"
import style1 from "./ListHoiChan.vue?vue&type=style&index=1&id=baa9abc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9abc0",
  null
  
)

export default component.exports